import { Button, Chip, Pagination } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import UploadPaymentProof from "../uploadPaymentProof";
import ViewPaymentProof from "../viewPaymentProof";
import getArticleService from "../../../../services/getArticleService";

import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getPublicationColor } from "../../../../config/publicationColors";
import { getPaymentStatus } from "../../../../utils/paymentStatus";
import ViewPdf from "../viewPdf";
import { Details } from "@mui/icons-material";

const columns = [
  { id: "id", label: "Article id", minWidth: 150, align: "center" },

  {
    id: "Publication Name",
    label: "Publication Name",
    minWidth: 150,
    format: (value) => value.toLocaleString("en-US"),
    align: "center",
  },

  {
    id: "Email id",
    label: "Payer Email",
    minWidth: 150,
    format: (value) => value.toLocaleString("en-US"),
    align: "center",
  },

  {
    id: "Payment Status",
    label: "Payment Status",
    minWidth: 200,
    format: (value) => value.toLocaleString("en-US"),
    align: "center",
  },

  {
    id: "Upload New Payment",
    label: "Upload New Payment",
    minWidth: 270,
    format: (value) => value.toFixed(2),
    align: "center",
  },
];

function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}

const rows = [
  createData("India", "IN", 1324171354, 3287263),
  createData("China", "CN", 1403500365, 9596961),
  createData("Italy", "IT", 60483973, 301340),
  createData("United States", "US", 327167434, 9833520),
  createData("Canada", "CA", 37602103, 9984670),
  createData("Australia", "AU", 25475400, 7692024),
  createData("Germany", "DE", 83019200, 357578),
  createData("Ireland", "IE", 4857000, 70273),
  createData("Mexico", "MX", 126577691, 1972550),
  createData("Japan", "JP", 126317000, 377973),
  createData("France", "FR", 67022000, 640679),
  createData("United Kingdom", "GB", 67545757, 242495),
  createData("Russia", "RU", 146793744, 17098246),
  createData("Nigeria", "NG", 200962417, 923768),
  createData("Brazil", "BR", 210147125, 8515767),
];

const List = ({ getdata, fetchData, filterVal, setFilterVal }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [articleData, setArticleData] = useState(null);
  const [isOpenView, setIsOpenView] = React.useState(false);
  const [selectFileRow, setSelectFileRow] = useState();
  const [isOpenPdf, setIsOpenPdf] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  console.log("getData", getdata);
  const handleChangePage = (event, newPage) => {
    console.log("newPage", newPage);
    setFilterVal({ ...filterVal, pageNumber: newPage });
  };

  const uploadPaymentProof = (val) => {
    setIsOpen(true);
    setArticleData(val);
  };
  const viewPaymentProof = (val) => {
    console.log("Opening payment proof view for row:", val);
    console.log("Payments data:", val.payments);
    setIsOpenView(true);
    setArticleData(val);
  };

  const fetchPreSignedUrl = async () => {
    const filterVal = {
      key: selectFileRow?.file,
    };
    try {
      const data = await getArticleService.getFilePreSIgnedUrl(filterVal);
      setSelectFileRow();

      if (data) {
        const link = document.createElement("a");
        link.href = data;
        link.click();
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  useEffect(() => {
    if (selectFileRow?.file) {
      fetchPreSignedUrl();
    }
  }, [selectFileRow?.file]);

  const viewPdf = (val) => {
    if (val?.file) {
      setIsOpenPdf(true);
      setPdfData(val);
    }
  };

  return (
    <Paper sx={{ width: "100%", boxShadow: "none" }}>
      <TableContainer sx={{ minHeight: "74vh", maxHeight: "74vh" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {getdata?.length > 0 ? (
              getdata.map((row) => {
                const paymentStatus = getPaymentStatus(row);
                return (
                  <TableRow className="text-center" key={row.id}>
                    <TableCell align="center">
                      <Link to={`/client/article/${row.id}`}>{row.id}</Link>
                    </TableCell>

                    <TableCell align="center">
                      <Badge
                        bg={getPublicationColor(row.publicationDetails?.name)}
                        style={{
                          fontSize: "16px",
                          backgroundColor: getPublicationColor(
                            row.publicationDetails?.name
                          ),
                          color: "#fff",
                          padding: "8px 16px",
                          borderRadius: "20px",
                          fontWeight: "600",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          textTransform: "capitalize",
                        }}
                      >
                        {row.publicationDetails?.name}
                      </Badge>
                    </TableCell>

                    <TableCell align="center">{row.emailId}</TableCell>

                    <TableCell align="center">
                      <Chip
                        label={paymentStatus.label}
                        color={paymentStatus.color}
                        size="medium"
                        sx={{
                          fontWeight: 500,
                          minWidth: "120px",
                        }}
                      />
                    </TableCell>

                    <TableCell align="center">
                      {!row.paymentStatus && (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => uploadPaymentProof(row)}
                        >
                          Upload
                        </Button>
                      )}

                      {row.payments &&
                        (Array.isArray(row.payments)
                          ? row.payments.length > 0
                          : row.payments.split(",").length > 0) && (
                          <Button
                            variant="contained"
                            className="ms-2"
                            color="success"
                            onClick={() => viewPaymentProof(row)}
                          >
                            View
                          </Button>
                        )}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell
                  //   align="center"
                  colSpan={15}
                  style={{ padding: "30px", fontWeight: "bold" }}
                >
                  <h1>No Data Found</h1>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="d-flex justify-content-end mt-3 mb-3 px-4">
        <Pagination
          page={filterVal.pageNumber}
          onChange={handleChangePage}
          count={filterVal.totalPages}
          variant="outlined"
          color="primary"
        />
      </div>
      <UploadPaymentProof
        fetchData={fetchData}
        articleData={articleData}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
      <ViewPaymentProof
        articleData={articleData}
        isOpenView={isOpenView}
        setIsOpenView={setIsOpenView}
      />

      <ViewPdf
        articleData={pdfData}
        isOpenView={isOpenPdf}
        setIsOpenView={setIsOpenPdf}
      />
    </Paper>
  );
};

export default List;
